import React, {useEffect,useState, useContext, useRef} from 'react';
import { createRoot } from 'react-dom/client';
import { PiTrashLight } from "react-icons/pi";
import { LiaPlusSolid } from "react-icons/lia";
import client from '../client';

const RoleAuthorities = ({role,setRole}) => {
    const [addingAuthority,setAddingAuthority] = useState(false);
    const [selectedAuth,setSelectedAuth] = useState(null);
    const addButtonRef = useRef(null);

    const {request,errorMessage} = client;

    const add = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        setAddingAuthority(true);
        if(addButtonRef.current) {
            let maxHeight = 200;
            let padding = 0;
            let itemHeight = 32;
            let avaiAuthorities = [];
            await request('GET','authorities')
            .then((response) => {
                if(response && response.length > 0) {
                    for(let authority of response) {
                        if(!role.authorities.find((roleAuthority)=>{return roleAuthority == authority})) {
                            avaiAuthorities.push(authority);
                        }
                    }
                } else {
                    setAddingAuthority(false);
                }
            })
            .catch((error) => {
                console.log(error);
                setAddingAuthority(false);
            })
            let height = (padding * 2) + (avaiAuthorities.length * itemHeight);
            height = height > maxHeight? maxHeight:height;
            let rect = addButtonRef.current.getBoundingClientRect();
            let vh = document.documentElement.clientHeight;
            let top = rect.top + rect.height;
            if (top + height > vh) {
                top = rect.top - height;
            }
            const container = document.createElement('div');
            container.style.position = 'fixed';
            container.style.top = top+'px';
            container.style.left = rect.left+'px';
            container.style.width = 'auto';
            container.style.zIndex = 100;
            container.style.overflow = 'hidden';
            container.classList.add('shadow-2xl');
            container.classList.add('rounded-md')

            document.body.appendChild(container);
            const root = createRoot(container);

            const close = () => {
                root.unmount();
                container.remove();
                document.removeEventListener('click',close);
                setAddingAuthority(false);
            };

            document.addEventListener('click',close)
    
            // Render the component into the container
            root.render(
                <div onClick={e => e.stopPropagation()}
                    className='flex flex-col w-full bg-white overflow-y-auto'>
                    {avaiAuthorities.map((authority,i) => 
                        <div key={i} 
                            onClick={(e) => {
                                let roleAuthorities = role.authorities;
                                roleAuthorities.push(authority);
                                setRole({...role,authorities:roleAuthorities});
                                close();
                            }} 
                            style={{height:itemHeight+'px'}} 
                            className='flex items-center w-full text-sm cursor-pointer shrink-0 text-text hover:text-white hover:bg-[rgb(0,175,240)]'>
                                <p className='px-8'>{authority}</p>
                        </div>
                    )}
                </div>
            );
        }
    }
  return (
    <div className='flex flex-col w-full h-auto space-y-2'>
        <p className='text-sm text-gray-600 capitalize'>Authorities</p>
        <div className='flex flex-col w-full h-auto p-4 space-y-4 border rounded-lg'>
            {role && role.authorities && role.authorities.map((authority,i) => 
            <div key={i} 
                onClick={(e) => {
                    setSelectedAuth(authority); 
                }}
                className='flex flex-row space-x-4'>
                <p className={`flex flex-row w-full h-auto text-sm tracking-wider whitespace-nowrap overflow-ellipsis capitalize ${selectedAuth === authority?'text-[rgb(0,175,240)]':''} cursor-pointer`}>
                    {authority}
                </p>
            </div>)
            }
        </div>
        <div className='flex flex-row w-auto h-auto space-x-4'>
            <button ref={addButtonRef} 
                onClick={(e) => {
                    add(e);
                }} 
                className={`flex w-6 h-6 items-center justify-center ${addingAuthority?'border border-[rgb(0,175,240)] text-[rgb(0,175,240)]':'bg-[rgb(0,175,240)] text-white hover:bg-[rgba(0,175,240,.8)]'}  rounded-md`}>
                <LiaPlusSolid size={16}/>
            </button>
            <button onClick={(e) => {
                    let authorities = role.authorities.filter((roleAuthority => roleAuthority !== selectedAuth));
                    setRole({...role,authorities:authorities});
                    setSelectedAuth(null);
                }} 
                disabled={!selectedAuth}
                className={`flex w-6 h-6 items-center justify-center ${selectedAuth?'bg-[rgb(0,175,240)] hover:bg-[rgba(0,175,240,.9)]':'bg-[rgba(0,175,240,.9)]'} text-white rounded-md`}>
                <PiTrashLight size={16}/>
            </button>
        </div>
    </div>
  )
}

export default RoleAuthorities